import '../assests/CSS/footer.css';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-container">
                {/* Left Section */}
                <div className="footer-left">
                    <div className="footer-logo" style={{ color: "white", fontWeight: "bold" }}>
                        Thhiya<span style={{ color: "red", fontSize:"1.5rem" }}>.</span>
                    </div>
                    <p>Your Intelligent Global B2B Connection.</p>
                    <p>© 2025 Thhiya. All Rights Reserved.</p>
                    <div className="social-links">
                        <i className="fab fa-facebook-f"></i>
                        <i className="fab fa-twitter"></i>
                        <i className="fab fa-linkedin-in"></i>
                        <i className="fab fa-instagram"></i>
                    </div>
                </div>

                {/* Right Section */}
                <div className="footer-right">
                    {/* Column 1 */}
                    <div className="footer-columns">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li><Link to="/">How It Works</Link></li>
                            <li><Link to="/">Why Thhiya</Link></li>
                        </ul>
                    </div>

                    {/* Column 2 */}
                    <div className="footer-columns">
                        <ul>
                            <li><Link to="/">Submit a Request</Link></li>
                            <li><Link to="/">List Your Business</Link></li>
                            <li><Link to="/">Browse Partner</Link></li>
                        </ul>
                    </div>

                    {/* Column 3 */}
                    <div className="footer-columns">
                        <ul>
                            <li><Link to="/">About Us</Link></li>
                            <li><Link to="/">Contact Us</Link></li>
                        </ul>
                    </div>

                    {/* Column 4 */}
                    <div className="footer-columns">
                        <ul>
                            <li><Link to="/">Privacy Policy</Link></li>
                            <li><Link to="/">Terms of Service</Link></li>
                            <li><Link to="/">Cookie Policy</Link></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
